import { TransactionFieldProps } from "../Transactions/TransactionTable";
import { LoanFromRestructureTag } from "@/components/LoanTags";

export const TransactionTag = ({ transaction }: TransactionFieldProps) => {
  const isLoanFromRestructure = !!transaction.restructured_from_loans_ids?.length;

  return isLoanFromRestructure ? <LoanFromRestructureTag /> : null;
};
